var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparklesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3915_2005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5957 12.5938C4.5957 9.37747 2.85756 6.5 0.40625 6.5C2.85756 6.5 4.5957 3.62233 4.5957 0.40625C4.5957 3.62233 6.33384 6.5 8.78516 6.5C6.33384 6.5 4.5957 9.37747 4.5957 12.5938Z",
    fill: "url(#paint0_linear_3915_2005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54795 6.5C9.54795 4.89166 8.67919 3.45312 7.45312 3.45312C8.67919 3.45312 9.54795 2.01419 9.54795 0.40625C9.54795 2.01419 10.4167 3.45312 11.6428 3.45312C10.4167 3.45312 9.54795 4.89166 9.54795 6.5Z",
    fill: "url(#paint1_linear_3915_2005)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5011 12.5938C10.5011 10.9856 9.63231 9.54688 8.40625 9.54688C9.63211 9.54688 10.5011 8.10794 10.5011 6.5C10.5011 8.10794 11.3698 9.54688 12.5959 9.54688C11.3698 9.54688 10.5011 10.9856 10.5011 12.5938Z",
    fill: "url(#paint2_linear_3915_2005)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3915_2005",
    x1: 4.5957,
    y1: 0.40625,
    x2: 4.5957,
    y2: 12.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3915_2005",
    x1: 9.54795,
    y1: 0.40625,
    x2: 9.54795,
    y2: 6.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3915_2005",
    x1: 10.5011,
    y1: 6.5,
    x2: 10.5011,
    y2: 12.5938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90205D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE4352",
    stopOpacity: 0.969
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3915_2005"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparklesSmall);
export default __webpack_public_path__ + "static/media/sparklesSmall.1d23f768.svg";
export { ForwardRef as ReactComponent };